module.exports = __webpack_public_path__ + "img/lunbo223.df0d517.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo223.png
// module id = hbDc
// module chunks = 0